import { Theme } from '@mui/material';

// The app's xs breakpoint starts at 576px; base styles must also cover narrower screens.
export const cardSx = (theme: Theme) => ({
	p: 2,
	minWidth: 0,
	borderRadius: '16px',
	[theme.breakpoints.up('sm')]: { p: 3 },
});

export const twoColumnsSx = (theme: Theme) => ({
	display: 'grid',
	gridTemplateColumns: 'minmax(0, 1fr)',
	gap: '16px',
	minWidth: 0,
	[theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
});

export const nextButtonSx = (theme: Theme) => ({
	width: '100%',
	minWidth: 0,
	whiteSpace: 'normal',
	[theme.breakpoints.up('sm')]: { width: 'auto' },
});
